import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MdExpandMore from 'react-icons/lib/md/expand-more';

import css from '../../styles/instrument/currencycalculator';

class Currency extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,

        ITEM: PropTypes.string,
        SECTOR: PropTypes.string,
        LONG_NAME: PropTypes.string,
        SHORT_NAME: PropTypes.string,
        LAST: PropTypes.number,
        LASTNZ: PropTypes.number,
        LASTNZ_DIV: PropTypes.number,

        symbol: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,

        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        changeCurrency: PropTypes.func,
        currencyList: PropTypes.array,
        onNewProps: PropTypes.func,

        changeable: PropTypes.bool,
        breakpoint: PropTypes.bool,

        requestTickerData: PropTypes.func,
    }

    constructor(props) {
        super(props);

        this.state = {
            multiplier: this.props.LAST || this.props.LASTNZ || this.props.LASTNZ_DIV,
        };

        this._passFocus = () => {
            this.input.focus();
        };

        this._generateSymbol = () => {
            if (this.props.SECTOR === 'CRYPTO') {
                return this.props.SHORT_NAME;
            }

            const ticker = this.props.ITEM.split(':')[1];

            return ticker.substring(1, 4);
        };

        this._formatNumber = (num) => {
            if (num === parseInt(num, 10)) {
                return num.toFixed(0);
            }
            if (num > 9999.99) {
                return num.toFixed(0);
            }

            return (num > 999.99) ? num.toFixed(1) : num.toFixed(2);
        };

        this._onCurrencyClick = e => {
            const { value } = e.target;

            this.props.changeCurrency(this.props.id, value);
        };
    }

    componentDidMount() {
        if (this.props.symbol !== 'X:SSEKSEK.IDCFX') {
            this.props.onNewProps(this.props, this.props.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        const prevMultiplier = this.props.LAST || this.props.LASTNZ || this.props.LASTNZ_DIV;
        const nextMultiplier = nextProps.LAST || nextProps.LASTNZ || nextProps.LASTNZ_DIV;
        if (nextMultiplier !== prevMultiplier) {
            if (nextProps.ITEM) {
                this.props.onNewProps(nextProps, this.props.id);

                // @TODO Add requestTickerData here to make the component completely independent?
            }
        }
    }

    render() {
        const inputProps = {
            type: 'number',
            autoComplete: 'off',
            className: css.input,
            onChange: this.props.onChange,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur,
        };

        const className = [css.name];
        if (this.props.changeable) {
            className.push(css.changeable);
        }
        if (this.props.breakpoint) {
            className.push(css.fontSmall);
        }

        return (
            <div className={css.group} onClick={() => this._passFocus()}>
                <div className={css.symbol}>
                    <span>{this._generateSymbol()}</span>
                </div>
                <div className={css.inputWrapper}>
                    <input
                        id={this.props.id}
                        type="number" step="1" min="0" pattern="[0-9]+([\.,][0-9]+)?"
                        value={this._formatNumber(this.props.value)}
                        ref={node => { this.input = node; }}
                        {...inputProps}
                    />
                </div>
                {this.props.changeable ? (
                    <div
                        className={className.join(' ')}
                        onClick={(e) => (e.stopPropagation())}
                    >
                        <span>
                            <select
                                defaultValue={this.props.symbol}
                                onChange={this._onCurrencyClick}
                            >
                                <option
                                    key="X:SSEKSEK.IDCFX"
                                    value="X:SSEKSEK.IDCFX"
                                >
                                    Svensk krona
                                </option>
                                {this.props.currencyList.map((option) => (
                                    <option
                                        key={option.ITEM_SECTOR}
                                        value={option.ITEM_SECTOR}
                                    >
                                        {option.LONG_NAME}
                                    </option>
                                ))};
                            </select>
                            <span className={css.chevron}><MdExpandMore /></span>
                        </span>
                    </div>
                ) : (
                    <div className={className.join(' ')}>
                        <span>
                            {this.props.LONG_NAME}
                        </span>
                    </div>
                )}
            </div>
        );
    }
}

export default Currency;



/** WEBPACK FOOTER **
 ** /src/shared/components/currencycalculator/Currency.js
 **/